import { gql } from '@apollo/client';

export const DELETE_SUBMISSION = gql`
  mutation DeleteSubmission($where: WhereRecordUniqueInput!) {
    deleteRecord(where: $where)
  }
`;
